import { RawInput, Validation } from '@ps/web-shared-components';
import { debounce } from 'lodash';
import React, { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import SearchIcon from '@swf/core/assets/icons/icon-search.svg';
import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';
import { SEARCH_FILTER_COLUMN_ID } from '@swf/poker';

import { usePokerMultiTableTournamentsWidget } from '../../../../model';

import { TXTCLI_Search_tournaments } from './SearchInput.messages.json';
import styles from './SearchInput.scss';

const SearchInput: React.FC = () => {
  const { widgetDispatch } = usePokerMultiTableTournamentsWidget();
  const { formatMessage } = useIntl();
  const { localSettings } = useDispatch<Dispatch>();
  const { poker } = useSelector(select.localSettings.get);

  const handleOnChange = useMemo(
    () =>
      debounce((e: React.ChangeEvent<HTMLInputElement>) => {
        widgetDispatch.setTableFilters([{ id: SEARCH_FILTER_COLUMN_ID, value: e.target.value }]);
        localSettings.set({
          poker: { tournaments: { search: e.target.value } }
        });
      }, 300),
    [widgetDispatch, localSettings]
  );

  useEffect(() => {
    const searchValue = poker?.tournaments?.search || '';
    if (searchValue) {
      widgetDispatch.setTableFilters([{ id: SEARCH_FILTER_COLUMN_ID, value: searchValue }]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RawInput
      id="tournament-search"
      label={TXTCLI_Search_tournaments}
      autoComplete="off"
      validationVariant={Validation.Invisible}
      hideLabel
      icon={SearchIcon}
      startAdornment="icon"
      onChange={handleOnChange}
      className={styles.searchInput}
      placeholder={formatMessage(TXTCLI_Search_tournaments)}
      defaultValue={poker?.tournaments?.search || ''}
    />
  );
};

export default SearchInput;
